<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="集采材料控制"
      destroy-on-close
      :visible.sync="show"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" :model="form" label-width="160px" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="是否控制有效期内集采合同的材料" prop="value1">
                <el-select v-model="form.value1" placeholder="请选择" style="width: 500px" @change="changeValue">
                  <el-option v-for="item in dimensionOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="集采采购申请是否生成预制订单" prop="value2">
                <el-select v-model="form.value2" placeholder="请选择" style="width: 500px" :disabled="form.value1 == '0'">
                  <el-option v-for="item in dimensionOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },

  data() {
    return {
      show: false,
      dimensionOptions: [],
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      form: { value1: '0', value2: '0' },
      rules: {
        value1: [
          {
            required: true,
            message: '请选择是否控制有效期内集采合同的材料',
            trigger: 'change'
          }
        ],
        value2: [
          {
            required: true,
            message: '请选择集采采购申请是否生成预制订单',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      that.dimensionOptions = utils.findDictList('sfdy1', that.allDataDict)
    })
  },
  methods: {
    // 根据租户获取配置
    getDetail(refId) {
      this.form = { refId: refId, value1: '', value2: '' }
      let that = this
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=concentrate_apply_material_is_purchase').then((resp) => {
        if (resp && resp.data) {
          if (resp.data.sub_data_switch_config_detail.length) this.form = Object.assign({}, this.form, resp.data.sub_data_switch_config_detail[0])
          this.form.value1 = utils.isEmpty(this.form.valid_ids) ? '0' : this.form.valid_ids
          this.form.value2 = utils.isEmpty(this.form.valid_type) ? '0' : this.form.valid_type
          this.show = true
        }
      })
    },
    changeValue() {
      if (this.form.value1 == '0') {
        this.form.value2 = '0'
      }
    },
    //关闭表单
    handleClose() {
      this.show = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      this.form.valid_ids = this.form.value1
      this.form.valid_type = this.form.value2
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .put('${portal}/portal/data_switch_config_detail/updateList', [this.form])
            .then((res) => {
              if (res.data.state) {
                this.$message.info('保存成功！')
              } else {
                this.$message.error('保存失败！')
              }
              this.loading = false
              this.handleClose()
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped></style>
